import { API } from 'utils/Helper';

export const gameLaunch = async ({ user_code, provider_code, game_code }) => {
  const response = await fetch(`${API}/game_launch`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ user_code: String(user_code), provider_code, game_code }),
  });
  if (!response.ok) throw new Error("Network response was not ok");
  return response.json();
};

export const gameLaunchNew = async ({ user_code, game_code }) => {
  const response = await fetch(`${API}/game_launch_new`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ user_code: String(user_code), game_code }),
  });
  if (!response.ok) throw new Error("Network response was not ok");
  return response.json();
};

export const fetchGameList = async (provider) => {
  const response = await fetch(`${API}/game-list?s=${provider}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error("Network response was not ok");
  const result = await response.json();
  return result.games || [];
};

export const fetchGameListNew = async (provider) => {
  const response = await fetch(`${API}/game-list-new?lable=${provider}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!response.ok) throw new Error("Network response was not ok");
  const result = await response.json();
  if (result.games && result.games[provider]) {
    return result.games[provider];
  }
  throw new Error(`No games found for the provider: ${provider}`);
};

export const authWBGames = async ({ user_code, prd }) => {
  const response = await fetch(`${API}/authWBGames`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ user_code: String(user_code), prd }),
  });
  if (!response.ok) throw new Error("Failed to launch game");
  return response.json();
};
